import {
    DatiqInputTypes,
    IDatiqInput,
    IDatiqOption,
} from '@dat/datiq-components-pkg/utils';
import { Mapper, SelectControl, Option, Control } from '../../../models';
import {
    DatiqSelectEnumStyle,
    IDatiqSelect,
    emptyDatiqSelect,
} from '@dat/datiq-components-pkg/select';

const optionMapper = (option: Option): IDatiqOption => ({
    id: option.id,
    value: option.value,
    display: option.display,
    data: option.data,
});

const optionListMapper = (options: Option[] = []): IDatiqOption[] => {
    return options.map((option: Option): IDatiqOption => optionMapper(option));
};

const mapper: Mapper = {
    map: (control: Control): IDatiqSelect => {
        if (control.type !== 'Select') throw new Error('Invalid control type');
        const options = optionListMapper(control.options);
        const value = control.value?.value?.length
            ? options.find(
                  (option: Option): boolean =>
                      option.value === control.value.value,
              ) ?? null
            : null;

        return {
            ...emptyDatiqSelect,
            type: DatiqInputTypes.Select,
            id: control.id,
            name: control.name,
            required: control.required,
            multiple: !!control.multi,
            style:
                control.style === 'standard'
                    ? DatiqSelectEnumStyle.Standard
                    : control.style === 'thin'
                    ? DatiqSelectEnumStyle.Thin
                    : control.style === 'dark'
                    ? DatiqSelectEnumStyle.Dark
                    : DatiqSelectEnumStyle.Standard,
            label: control.label,
            value,
            options: optionListMapper(control.options),
        };
    },
};

export default mapper;
